import { useEffect, useState, forwardRef } from 'react';
import './itinerary.css';
import CharCount from '../../charCount/CharCount';
import ReactQuill from 'react-quill';
import { modules } from '../../../utils/quillModules';
import 'react-quill/dist/quill.snow.css';
import DropdownReg from '../../dropdownReg/DropdownReg';
import useSectionHighlightRef from '../../../hooks/useSectionHighlightRef';
import { formats } from '../../../utils/quillFormats';

const Itinerary = forwardRef(({ packData, setPackData }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const [itnCount, setItnCount] = useState(packData?.itinerary?.length);
    const itiType_options = ['fixed', 'custom'];

    useEffect(() => {
        // if (!isEdit) return;
        setItnCount(packData?.itinerary.length);
        //eslint-disable-next-line
    }, [packData?.itinerary]);

    function handleItinerary(e, index, type) {
        setPackData((prevState) => {
            const updatedArray = prevState.itinerary.map(function (item, itemKey) {
                if (index === itemKey) {
                    if (type === 'dayHeading') return { ...item, [e.target.name]: e.target.value };
                    else return { ...item, dayDescription: e };
                }
                return item;
            });
            return {
                ...prevState,
                itinerary: updatedArray
            };
        });
    }

    function addDay() {
        setPackData(function (prevState) {
            return {
                ...prevState,
                itinerary: [...prevState.itinerary, { dayHeading: '', dayDescription: '' }]
            };
        });
        setItnCount(itnCount + 1);
    }

    const deleteDay = () => {
        console.log(itnCount);
        if (itnCount > 1) {
            setPackData((prevState) => {
                const updatedArray = [...prevState.itinerary];
                updatedArray.pop(); //pop should used here only, if use pop in the above line, it returns
                //the removed item which is not the expected outcome
                return {
                    ...prevState,
                    itinerary: updatedArray
                };
            });
            setItnCount(itnCount - 1);
        }
    };
    console.log(packData);
    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Itinerary</h2>
            <DropdownReg
                label='Itinerary Type'
                name={'itiType'}
                options={itiType_options}
                value={packData?.itiType}
                req={true}
                setFormData={setPackData}
                error={highlightField === 'itiType'}
            />
            <div className='orgPackUpSecDiv'>
                {(packData?.itinerary.length > 1 ? packData?.itinerary : Array.apply(null, { length: itnCount })).map(
                    function (_, itnKey) {
                        return (
                            <div key={itnKey}>
                                <p className='itineraryLabel'>Day {itnKey}</p>
                                <div className='itineraryInDiv'>
                                    <label className='itineraryLabel'>Heading</label>
                                    <div className='itineraryInputDiv'>
                                        <input
                                            value={
                                                packData?.itinerary[itnKey]
                                                    ? packData?.itinerary[itnKey]?.dayHeading
                                                    : ''
                                            }
                                            type='text'
                                            name='dayHeading'
                                            onChange={(e) => handleItinerary(e, itnKey, 'dayHeading')}
                                            placeholder={`Day ${itnKey} Heading`}
                                            className='itineraryInput'
                                        ></input>
                                        <CharCount
                                            string={
                                                packData?.itinerary[itnKey]
                                                    ? packData?.itinerary[itnKey]?.dayHeading
                                                    : ''
                                            }
                                            min={3}
                                            limit={60}
                                        />
                                    </div>
                                </div>
                                <div className='itineraryDiv'>
                                    <label className='itineraryLabel'>Description</label>
                                    <div className='itineraryDescDiv'>
                                        {/* <textarea
                                        value={
                                            packData.itinerary[itnKey] ? packData.itinerary[itnKey].dayDescription : ''
                                        }
                                        name='dayDescription'
                                        onChange={(e) => handleItinerary(e, itnKey)}
                                        placeholder={`Day ${itnKey} Description`}
                                        className='itineraryInput textArea'
                                        disabled={
                                            isEdit && packData.status !== 'inactive' && packData.status !== 'rejected'
                                        }
                                    ></textarea> */}
                                        <ReactQuill
                                            name='dayDescription'
                                            value={
                                                packData?.itinerary[itnKey]
                                                    ? packData?.itinerary[itnKey].dayDescription
                                                    : ''
                                            }
                                            onChange={(e) => handleItinerary(e, itnKey, 'dayDescription')}
                                            theme='snow'
                                            placeholder={`Day ${itnKey} Description`}
                                            // className='itineraryInput textArea'
                                            modules={modules}
                                            formats={formats}
                                        />
                                        <CharCount
                                            string={
                                                packData?.itinerary[itnKey]
                                                    ? packData?.itinerary[itnKey].dayDescription
                                                    : ''
                                            }
                                            min={20}
                                            limit={1500}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    }
                )}
                <div className='alignButtons itinBtn'>
                    <button
                        type='button'
                        onClick={() => {
                            addDay();
                        }}
                        className={`itineraryAddBtn blueBtn `}
                    >
                        Add Day
                    </button>
                    <button
                        type='button'
                        onClick={() => {
                            deleteDay();
                        }}
                        className={`itineraryDelBtn`}
                        // disabled={itnCount === 1 || isEdit ? true : false}
                    >
                        Delete day
                    </button>
                </div>
            </div>
        </div>
    );
});

export default Itinerary;
